"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _clsx = _interopRequireDefault(require("clsx"));
var _commonRichText = _interopRequireDefault(require("./common-rich-text.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var createMarkup = function createMarkup(html) {
  if (html === void 0) {
    html = '';
  }
  var getHTML = function getHTML() {
    if (typeof DOMParser === 'undefined') {
      return html;
    }
    var data = new DOMParser().parseFromString(html, 'text/html');
    return data.body !== null ? data.body.innerHTML : html;
  };
  return {
    __html: getHTML()
  };
};
var getStyle = function getStyle(format, renderTheme) {
  if (format === 'none') {
    return undefined;
  }
  if (format === 'legal') {
    return handleNestedProp(renderTheme, 'renderTheme.smallType');
  }
  // richTextPassThrough class only changes text colour not any of the styles
  return handleNestedProp(renderTheme, 'renderTheme.richTextPassThrough');
};
var CommonRichText = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function CommonRichText() {
    return _React$Component.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(CommonRichText, _React$Component);
  CommonRichText.resourceType = function resourceType() {
    return 'CommonRichText';
  };
  var _proto = CommonRichText.prototype;
  _proto.getTagName = function getTagName() {
    var _this$props = this.props,
      forceTag = _this$props.forceTag,
      html = _this$props.html,
      tagName = _this$props.tagName;
    var isPlainString = html && !html.includes('<') && !html.includes('>');
    if (forceTag || isPlainString && tagName) {
      return tagName;
    }
    return 'div';
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      theme = _this$props2.theme,
      format = _this$props2.format,
      html = _this$props2.html,
      className = _this$props2.className;
    var tagName = this.getTagName();
    if (html && html !== ' ') {
      return /*#__PURE__*/_react["default"].createElement(tagName, {
        className: (0, _clsx["default"])(_commonRichText["default"].richText, getStyle(format, theme), className),
        dangerouslySetInnerHTML: createMarkup(html)
      });
    }
    return '';
  };
  return CommonRichText;
}(_react["default"].Component);
CommonRichText.displayName = 'CommonRichText';
CommonRichText.defaultProps = {
  forceTag: false,
  format: 'standard',
  tagName: 'div'
};